import React from 'react';
import { useParams } from "react-router-dom";
const statsData = [
  {
    icon: 'fa-regular fa-face-smile',
    endValue: 232,
    text: 'Happy Clients',
  },
  {
    icon: 'fa-solid fa-book-open',
    endValue: 521,
    text: 'Projects',
  },
  {
    icon: 'fa-solid fa-headset',
    endValue: 1463,
    text: 'Hours Of Support',
  },
  {
    icon: 'fa-solid fa-users',
    endValue: 15,
    text: 'Hard Workers',
  },
];

function LiveStream() {
  const { section, id } = useParams();
  return (
    <section id="stats" className="stats section">
      <div className="container" data-aos="fade-up" data-aos-delay={100}>
        
          <div style={{width: '100%', margin: 0, border: '#ccc thin solid'}}>
            <span className="style32" style={{padding: '1%'}}>Live Stream Event</span>
          </div>
          <div  style={{width: '100%', margin: 0, borderRightWidth: 'thin', borderBottomWidth: 'thin', borderLeftWidth: 'thin', borderRightStyle: 'solid', borderBottomStyle: 'solid', borderLeftStyle: 'solid', borderRightColor: '#CCC', borderBottomColor: '#CCC', borderLeftColor: '#CCC'}}>
            <p className="font_size">
              <iframe width="100%" height="auto" src="http://cdn.livestream.com/embed/fminigeria?layout=4&height=340&width=560&autoplay=false" style={{border: 0, outline: 0}} frameBorder={0} scrolling="no" />
            
              <div style={{fontSize: 11, paddingTop: 10, textAlign: 'center', width: '90%'}}>
                <a href="http://www.livestream.com/fminigeria?utm_source=lsplayer&utm_medium=embed&utm_campaign=footerlinks" title="Watch fminigeria">
                fminigeria
                </a> on livestream.com.
                <a href="http://www.livestream.com/?utm_source=lsplayer&utm_medium=embed&utm_campaign=footerlinks" title="Broadcast Live Free">
                  Broadcast Live Free
                </a>
              </div>
            </p>
          </div>
        
      </div>
    </section>
  );
}

export default LiveStream;